import { PRODUCT_TYPE, PRODUCT_NAME } from '@constants';
import useProductsContext from './useProductsContext';

const {
  RETURN_ASSURANCE, BUYER_PROTECTION, SHIPPING_PROTECTION, GREEN_SHIPPING_PROTECTION, ASSURED_SALE, EXTENDED_WARRANTY, DELIVERY_GUARANTEE,
} = PRODUCT_NAME;

const TabCodeMap = {
  [RETURN_ASSURANCE]: PRODUCT_TYPE.Return,
  [BUYER_PROTECTION]: PRODUCT_TYPE.Buyer,
  [SHIPPING_PROTECTION]: PRODUCT_TYPE.Buyer,
  [GREEN_SHIPPING_PROTECTION]: PRODUCT_TYPE.Buyer,
  [ASSURED_SALE]: PRODUCT_TYPE.Assured,
  [EXTENDED_WARRANTY]: PRODUCT_TYPE.Extended,
  [DELIVERY_GUARANTEE]: PRODUCT_TYPE.Buyer,
};

/** 根据产品判断需要列表页有哪些 tabs */
export const useTabs = () => {
  const {
    productsGallery,
    galleryLoading,
  } = useProductsContext();
  const activeProducts = productsGallery
    ?.filter((item) => (item.status === 'live' && item.involvedStatus)) || [];
  const tabs = activeProducts.map((item) => ({
    name: item.insuranceName,
    code: TabCodeMap[item.insuranceName],
  })).filter((item) => item.code !== undefined); // 过滤掉buyback guarantee 和extend warranty
  return {
    tabs,
    isTabLoading: galleryLoading,
  };
};
